/* Studio Spice · Brand v1.1 behaviour (header, drawer, search, tabs, bands) */
(function () {
  var d = document, w = window, root = d.documentElement;
  root.classList.add('js-sb');
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nl = (root.lang || '').indexOf('nl') === 0;

  /* ---------------- header ---------------- */
  function header() {
    var sec = $('.sb-hdr-section'); if (!sec) return;
    var hdr = $('[data-sb-header]', sec);
    function setH() { root.style.setProperty('--header-height', sec.offsetHeight + 'px'); }
    setH(); w.addEventListener('resize', setH);

    var megas = $$('[data-sb-mega]', sec), closeT;
    var sp = $('[data-sb-search]', sec), si = $('[data-sb-search-input]', sec), sr = $('[data-sb-search-results]', sec), pop = $('[data-sb-search-pop]', sec);
    var opener = $('[data-sb-search-open]', sec);
    var dr = $('[data-sb-drawer]', sec), burger = $('[data-sb-drawer-open]', sec);
    function megaOpen() { return megas.some(function (m) { return $('[data-sb-mega-panel]', m).classList.contains('is-open'); }); }
    function anyOpen() { return megaOpen() || (sp && !sp.hidden) || root.classList.contains('sb-lock'); }

    var last = w.pageYOffset, ticking = false;
    function onScroll() {
      var y = w.pageYOffset;
      sec.classList.toggle('is-scrolled', y > 4);
      if (!anyOpen()) {
        if (y > last + 6 && y > sec.offsetHeight + 40) sec.classList.add('is-hidden');
        else if (y < last - 6 || y < 80) sec.classList.remove('is-hidden');
      }
      last = y; ticking = false;
    }
    w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    function openMega(li) {
      megas.forEach(function (m) { if (m !== li) closeMega(m); });
      if (sp && !sp.hidden) closeSearch();
      $('button', li).setAttribute('aria-expanded', 'true'); $('[data-sb-mega-panel]', li).classList.add('is-open'); hdr.classList.add('is-open');
    }
    function closeMega(li) {
      $('button', li).setAttribute('aria-expanded', 'false'); $('[data-sb-mega-panel]', li).classList.remove('is-open');
      if (!megaOpen() && (!sp || sp.hidden)) hdr.classList.remove('is-open');
    }
    var hover = w.matchMedia('(hover:hover) and (min-width: 990px)');
    megas.forEach(function (li) {
      var b = $('button', li);
      b.addEventListener('click', function () { b.getAttribute('aria-expanded') === 'true' ? closeMega(li) : openMega(li); });
      li.addEventListener('mouseenter', function () { if (hover.matches) { clearTimeout(closeT); openMega(li); } });
      li.addEventListener('mouseleave', function () { if (hover.matches) { closeT = setTimeout(function () { closeMega(li); }, 160); } });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) closeMega(li); });
    });

    function openSearch() {
      megas.forEach(closeMega);
      sp.hidden = false; sp.classList.add('is-in'); hdr.classList.add('is-open'); opener.setAttribute('aria-expanded', 'true');
      sec.classList.remove('is-hidden');
      setTimeout(function () { si && si.focus(); }, 40);
    }
    function closeSearch() {
      if (!sp || sp.hidden) return;
      sp.hidden = true; sp.classList.remove('is-in'); opener.setAttribute('aria-expanded', 'false');
      if (!megaOpen()) hdr.classList.remove('is-open');
    }
    if (sp) {
      $$('[data-sb-search-open]', sec).forEach(function (b) { b.addEventListener('click', function () { sp.hidden ? openSearch() : closeSearch(); }); });
      $$('[data-sb-search-close]', sec).forEach(function (b) { b.addEventListener('click', closeSearch); });
      d.addEventListener('click', function (e) { if (!sp.hidden && !sec.contains(e.target)) closeSearch(); });
      var tq, ctrl;
      function money(p) { var n = parseFloat(p); if (isNaN(n)) return ''; try { return new Intl.NumberFormat(root.lang || 'en', { style: 'currency', currency: (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || 'EUR' }).format(n); } catch (e) { return n.toFixed(2); } }
      si && si.addEventListener('input', function () {
        clearTimeout(tq);
        var q = si.value.trim();
        if (q.length < 2) { sr.innerHTML = ''; if (pop) pop.hidden = false; return; }
        tq = setTimeout(function () {
          if (ctrl) ctrl.abort(); ctrl = 'AbortController' in w ? new AbortController() : null;
          var base = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
          fetch(base + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article&resources[limit]=4&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.json(); })
            .then(function (j) {
              var res = (j.resources && j.resources.results) || {}, items = (res.products || []).concat(res.articles || []).slice(0, 4);
              if (pop) pop.hidden = true;
              var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
              if (!items.length) { sr.innerHTML = '<p class="sb-small">' + (nl ? 'Geen resultaten voor' : 'No results for') + ' “' + esc(q) + '”</p>'; return; }
              sr.innerHTML = '<div class="sb-search__list">' + items.map(function (it) {
                var img = it.image || (it.featured_image && it.featured_image.url) || '';
                if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=360';
                var sub = it.price ? money(it.price) : (it.published_at ? new Date(it.published_at).toLocaleDateString(root.lang || 'en', { day: 'numeric', month: 'short', year: 'numeric' }) : '');
                var title = String(it.title || '').split('|')[0].trim();
                return '<a class="sb-sres" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '<span class="sb-sres__t">' + esc(title) + '</span><span class="sb-sres__p">' + esc(sub) + '</span></a>';
              }).join('') + '</div><div class="sb-search__all"><a class="sb-link" href="' + base + 'search?q=' + encodeURIComponent(q) + '&type=product,article,page">' + (nl ? 'Bekijk alle resultaten' : 'View all results') + ' →</a></div>';
            }).catch(function () {});
        }, 180);
      });
    }

    function openDrawer() {
      if (!dr) return; dr.hidden = false; root.classList.add('sb-lock'); burger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { requestAnimationFrame(function () { dr.classList.add('is-open'); }); });
      var f = $('a,button,summary', $('.sb-drawer__nav', dr)); setTimeout(function () { f && f.focus({ preventScroll: true }); }, 350);
    }
    function closeDrawer() {
      if (!dr || dr.hidden) return; dr.classList.remove('is-open'); root.classList.remove('sb-lock'); burger.setAttribute('aria-expanded', 'false');
      setTimeout(function () { dr.hidden = true; burger.focus({ preventScroll: true }); }, reduce ? 0 : 380);
    }
    burger && burger.addEventListener('click', openDrawer);
    dr && $$('[data-sb-drawer-close]', dr).forEach(function (b) { b.addEventListener('click', closeDrawer); });

    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      megas.forEach(closeMega); closeSearch(); closeDrawer();
    });
  }

  /* ---------------- tabs ---------------- */
  function tabs() {
    $$('[data-sb-tabs]').forEach(function (t) {
      var btns = $$('[role="tab"]', t);
      function sel(b, focus) {
        btns.forEach(function (x) {
          var on = x === b, p = d.getElementById(x.getAttribute('aria-controls'));
          x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
          if (p) { p.hidden = !on; if (on) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); } }
        });
        if (focus) b.focus();
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { sel(b); });
        b.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = btns[(i + 1) % btns.length];
          if (e.key === 'ArrowLeft') n = btns[(i - 1 + btns.length) % btns.length];
          if (n) { e.preventDefault(); sel(n, true); }
        });
      });
    });
  }

  /* ---------------- benefits: items light up as they scroll in ---------------- */
  function benefits() {
    if (reduce || !('IntersectionObserver' in w)) return;
    var items = $$('.sb-benefits__item');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('sb-pre'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -15% 0px' });
    items.forEach(function (it) {
      if (it.getBoundingClientRect().top > w.innerHeight * 0.85) { it.classList.add('sb-pre'); io.observe(it); }
    });
  }

  /* ---------------- timeline progress ---------------- */
  function timeline() {
    $$('[data-sb-timeline]').forEach(function (tl) {
      var fill = $('.sb-tl__fill', tl), items = $$('.sb-tl__item', tl);
      function upd() {
        var r = tl.getBoundingClientRect(), mid = w.innerHeight * 0.55;
        if (fill) fill.style.height = Math.max(0, Math.min(r.height - 16, mid - r.top)) + 'px';
        items.forEach(function (it, i) { it.classList.toggle('is-on', i === 0 || it.getBoundingClientRect().top < mid); });
      }
      upd(); w.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    });
  }

  /* ---------------- misc ---------------- */
  function misc() {
    $$('[data-sb-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });
    $$('[data-sb-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var u = b.getAttribute('data-sb-copy');
        if (navigator.clipboard) navigator.clipboard.writeText(u).then(function () { b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1800); });
      });
    });
    /* in-page anchors (e.g. "Order your blend" → buy box): smooth scroll below the sticky header */
    $$('a[href="#MainContent"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = d.getElementById('MainContent'); if (!t) return;
        e.preventDefault();
        w.scrollTo({ top: t.getBoundingClientRect().top + w.pageYOffset - 8, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  ready(function () {
    [header, tabs, benefits, timeline, misc].forEach(function (f) { try { f(); } catch (e) { if (w.console) console.warn('sb', e); } });
  });
})();
